import styled from "styled-components";

export const StatusIcon = styled.img`
  height: 1.4rem;
`;
